<div cdkDropList (cdkDropListDropped)="formDropped($event)">
    <ng-container *ngFor="let elem of list" >
        <div cdkDrag class="nv-row-elem row">
            <div cdkDragHandle class="rowGrab">
                <div class="nv-shift-row col-1 my-3 ps-4">
                    <fa-icon class="nv-position-icon" [icon]="['far', 'grip-dots-vertical']"></fa-icon>
                </div>
               <p class="col-10 ps-0 my-3 text-truncate">{{ elem.name }}</p>
            </div>
        </div>
    </ng-container>
</div>
